// Feature: M004-F0774 (WebUI #246 phase 1). Pure helpers for the collapsible Advice card.
// Summary = the items of `listedAdvice` (never rejected/archived, never a Problem row) whose date is in the
// CURRENT Europe/London month; amounts are the adapter's `amount` (pounds, already fromMinor) summed per currency.

export const ADVICE_CARD_KEY = 'ledger.adviceCard.open';

const MONTH_FORMAT = new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/London', year: 'numeric', month: '2-digit' });
export function londonMonthKey(value) {
  const date = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(date.getTime())) return '';
  const parts = Object.fromEntries(MONTH_FORMAT.formatToParts(date).map((part) => [part.type, part.value]));
  return `${parts.year}-${parts.month}`;
}

// A date-only value ("2026-10-02") is a London calendar day already; an instant is converted to London time.
const itemMonthKey = (raw) => (/^\d{4}-\d{2}-\d{2}$/.test(String(raw || '')) ? String(raw).slice(0, 7) : londonMonthKey(raw));

export function adviceMonthSummary(items, money, now = new Date()) {
  const month = londonMonthKey(now);
  const totals = new Map();
  let count = 0;
  (items || []).forEach((item) => {
    if (!month || itemMonthKey(item.date) !== month) return;
    count += 1;
    const currency = item.currency || 'GBP';
    // Whole pennies, so a sum of 0.1 + 0.2 does not drift.
    totals.set(currency, (totals.get(currency) || 0) + Math.round(Number(item.amount || 0) * 100));
  });
  const amount = totals.size ? [...totals].map(([currency, minor]) => money(minor / 100, currency)).join(' + ') : money(0);
  return `${count} ${count === 1 ? 'item' : 'items'} · ${amount} this month`;
}

export function readAdviceCardOpen() {
  try { return window.localStorage.getItem(ADVICE_CARD_KEY) === 'true'; } catch (error) { return false; }
}
export function writeAdviceCardOpen(open) {
  try { window.localStorage.setItem(ADVICE_CARD_KEY, open ? 'true' : 'false'); } catch (error) { /* per-viewer convenience only */ }
}
